import React from 'react';
import styled from 'styled-components';

const ActivitiesSectionWrapper = styled.section`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直置中 */
  justify-content: center;
  padding: 5% 0%;
  background: #000000;
  

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

const ActivitiesSubtitle = styled.h3`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 32px;
  }
`;

const ActivitiesTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 75px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-top: 0px;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 12px;
  }
`;

const ActivitiesNumbersWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  width: 45%;



  @media (max-width: 500px) {
    
    width: 90vw;
  }
`;


const ActivityNumberBlock = styled.div`
  text-align: center;
  width: 100%;
  height: auto;
  

  & > div {
    font-size: 86px;
    color: #FFFF56;
  }

  & > p {
    font-size: 16px;
    color: #FFFFFF;
    margin-top:5%;

  }

  @media (max-width: 500px) {
    
    & > div {
      font-size: 36px;
    
  }

    & > p {
      font-size: 12px;
      

    }
  }
`;

const DividerLine = styled.div`
 



  background-color: #606060;
  width: 50%;
  height: 0px;
  margin: auto 0;
  border: 1px solid #606060;
  transform: rotate(90deg);

  @media (max-width: 500px) {
   
  }


`;

const ActivitiesImage = styled.img`
  width: 100%;
  height: auto;
  display:block;
  margin-top: 20px;

  @media (max-width: 500px) {
    display:none;

  }
`;

const ActivitiesImage_mobile = styled.img`
  width: 100%;
  height: auto;
  display:none;
  
  margin-top: 10px;

  @media (max-width: 500px) {
    display:block;
  }
`;

const Activities = () => (
  <ActivitiesSectionWrapper>
    <ActivitiesSubtitle>Activities</ActivitiesSubtitle>
    <ActivitiesTitle>活動成果</ActivitiesTitle>
    <ActivitiesNumbersWrapper>
      <ActivityNumberBlock>
        <div>1</div>
        <p>場國際會議</p>
      </ActivityNumberBlock>
      <DividerLine />
      <ActivityNumberBlock>
        <div>3</div>
        <p>場國際交流活動</p>
      </ActivityNumberBlock>
      <DividerLine />
      <ActivityNumberBlock>
        <div>10</div>
        <p>場DAO讀書會</p>
      </ActivityNumberBlock>
    </ActivitiesNumbersWrapper>
    <ActivitiesImage src="/images/Activities_Background.png" alt="Activities" />
    <ActivitiesImage_mobile src="/images/Activities_Background_mobile.png" alt="Activities" />
  </ActivitiesSectionWrapper>
);

export default Activities;
